import axios from "../utils/axios";

// ==========================================
// Admin Settings
// ==========================================

export const getSettings = async (params) => {
    const response = await axios.get("/admin/settings", { params });
    return response.data;
};

export const updateSettings = async (data) => {
    const response = await axios.patch("/admin/settings", data);
    return response.data;
};

// ==========================================
// Storefront Cache Invalidation
// ==========================================

export const invalidateNavigationCache = async () => {
    const response = await axios.post("/admin/cache/invalidate/navigation");
    return response.data;
};

export const invalidateHomeCache = async () => {
    const response = await axios.post("/admin/cache/invalidate/home");
    return response.data;
};
